module.exports = __webpack_public_path__ + "img/odins_wolves.625ae8c1.jpg";